import { GlobalContext } from "global/context/Provider";
import camelize from "global/utils/camelize";
import { useContext } from "react";
import MiInformeIcon from "_+_Portal/assets/images/generico/MiInformeIcon";
import MisLaboratoriosIcon from "_+_Portal/assets/images/generico/MisLaboratoriosIcon";
import { PortalContext } from "_+_Portal/context/Provider";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { BtnContainer, ContainerResultados } from "./localStyle";

const Resultados = () => {
  // -------------------------  context ----------------------------

  const { pasoDispatch } = useContext(AutocheckContext);
  const { authState } = useContext(GlobalContext);
  const { selectDropDownState } = useContext(PortalContext);
  // -------------------------  context ----------------------------

  // -------------------------  constantes ----------------------------
  const pacienteNombre = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.nombre
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.nombre
    : authState.auth.data.paciente.nombre;

  // -------------------------  constantes ----------------------------

  // -------------------------  funtions ----------------------------
  const handleOnclick = () => {};
  const handleVolver = () => {
    setPaso("Home")(pasoDispatch);
  };
  // -------------------------  funtions ----------------------------

  return (
    <LayoutPasos
      volverTo={handleVolver}
      title={camelize(pacienteNombre)}
      subtitle={"¿En qué podemos ayudarte hoy?"}
    >
      <ContainerResultados>
        <BtnContainer>
          <BtnLink
            Icon={<MiInformeIcon color={"var(--color-primary)"} />}
            to={"/misinformes"}
            title={"INFORME DE ESTUDIOS MÉDICOS"}
            onclick={handleOnclick}
          />
          <BtnLink
            Icon={<MisLaboratoriosIcon color={"var(--color-primary)"} />}
            to={"/mislaboratorios"}
            title={"RESULTADOS DE LABORATORIO"}
            onclick={handleOnclick}
          />
        </BtnContainer>
      </ContainerResultados>
    </LayoutPasos>
  );
};

export default Resultados;
